/**
 * Which render source partition this tile is parsed for.
 * Undefined/null = no filtering (single source, all layers).
 */
export const RenderSourceType = {
    Other: 0,
    Symbol: 1,
    FillExtrusion: 2,
    HdRoadCoverage: 3,
} as const;
export type RenderSourceType = typeof RenderSourceType[keyof typeof RenderSourceType];
